import { render } from "./TopSolution.vue?vue&type=template&id=2f0a9799&scoped=true&ts=true"
import script from "./TopSolution.vue?vue&type=script&lang=ts"
export * from "./TopSolution.vue?vue&type=script&lang=ts"

import "./TopSolution.vue?vue&type=style&index=0&id=2f0a9799&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0a9799"]])

export default __exports__